
<template>
  <div>
    <div class="reviewRank5">
      <div class="reviewRank5__title">
        <span class="reviewRank5__titleLeft"><slot name="titleLeft"></slot></span>
        <span class="reviewRank5__titleRight"><slot name="titleRight"></slot></span>
      </div>
      <div class="reviewRank5__flex">
        <template v-for="i in 5">
          <div>
            <input type="radio"
                   :id="id+'_'+i"
                   :name="id"
                   :value="i"
                   v-model="output">
            <label :for="id+'_'+i">
            </label>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    'val'
  ],
  data: function () {
    return {
      id: '',
      output: ''
    }
  },
  created: function () {
    this.output = this.val || ''
    this.id = 'reviewRank5_' + this._uid
  },
  watch: {
    'val': function () {
      this.output = this.val
    },
    'output': function () {
      this.output = this.output || ''
      this.$emit('input', this.output)
    }
  }
}
</script>


<style lang="scss">
  .reviewRank5 {
    &__title {
      display: block;

      &Left {
        float: left;
      }

      &Right {
        float: right;
      }

      &:after {
        content: "";
        clear: both;
        display: block;
      }
    }

    &__flex {
      display: flex;
      width: 100%;

      > div {
        flex: 1;
      }

      input {
        display: none;
      }

      label {
        border: 1px solid #cccccc;
        display: block;
        height: 20px;
        cursor: pointer;

      }

      input:checked + label {
        background-color: #18a689!important;
        /*&:before{*/
          /*content: "";*/
          /*text-align: center;*/

          /*color: #18a689;*/
        /*}*/

      }
    }
  }
</style>



// WEBPACK FOOTER //
// Rank5.vue?f23e9d62